import {useCallback, useEffect, useLayoutEffect, useRef} from "react"

export const useDraftLoadGuard = (identity, draft, onDraftEdit) => {
    const generationRef = useRef(0)
    const identityRef = useRef(identity)
    const previousDraftRef = useRef(draft)
    const draftVersionRef = useRef(0)
    useLayoutEffect(() => {
        identityRef.current = identity
        if (previousDraftRef.current !== draft) {
            previousDraftRef.current = draft
            draftVersionRef.current += 1
        }
    }, [identity, draft])

    useEffect(() => () => {
        generationRef.current += 1
    }, [identity])

    const beginDraftLoad = useCallback(() => {
        const generation = ++generationRef.current
        const identityAtStart = identityRef.current
        const draftVersionAtStart = draftVersionRef.current
        const isCurrent = () => (
            generationRef.current === generation
            && Object.is(identityRef.current, identityAtStart)
        )

        return {
            isCurrent,
            canApply: () => (
                isCurrent()
                && draftVersionRef.current === draftVersionAtStart
            ),
        }
    }, [])

    const onLocalEdit = useCallback(() => {
        draftVersionRef.current += 1
        onDraftEdit?.()
    }, [onDraftEdit])

    return {beginDraftLoad, onLocalEdit}
}
